/**
 * @flow
 * @relayHash 84d1ce17b73c1fd9848afd2f6eb9e05e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ClientWhere = {|
  and?: ?$ReadOnlyArray<?ClientWhere>,
  or?: ?$ReadOnlyArray<?ClientWhere>,
  id?: ?ConditionInputType,
  code?: ?ConditionInputType,
  name?: ?ConditionInputType,
  phone?: ?ConditionInputType,
  cellPhone?: ?ConditionInputType,
  email?: ?ConditionInputType,
  address?: ?ConditionInputType,
  taxName?: ?ConditionInputType,
  taxUUID?: ?ConditionInputType,
  isCredit?: ?ConditionInputType,
  daysCredit?: ?ConditionInputType,
  taxAddress?: ?ConditionInputType,
  documentType?: ?ConditionInputType,
  uuid?: ?ConditionInputType,
  locationId?: ?ConditionInputType,
  companyId?: ?ConditionInputType,
  notes?: ?ConditionInputType,
  collectorId?: ?ConditionInputType,
  isDisabled?: ?ConditionInputType,
  updateInfoRequired?: ?ConditionInputType,
  createdAt?: ?ConditionInputType,
  createdBy?: ?ConditionInputType,
  updatedAt?: ?ConditionInputType,
  updatedBy?: ?ConditionInputType,
  addressExt?: ?ConditionInputType,
  type?: ?ConditionInputType,
  contador?: ?ConditionInputType,
  lnglat?: ?ConditionInputType,
  departamento?: ?ConditionInputType,
  municipio?: ?ConditionInputType,
  grupoHabitacional?: ?ConditionInputType,
  nombreHabitacional?: ?ConditionInputType,
  vialidad?: ?ConditionInputType,
  numeroVialidad?: ?ConditionInputType,
  nombreVialidad?: ?ConditionInputType,
  zona?: ?ConditionInputType,
  numeroCasa?: ?ConditionInputType,
  tipoCasa?: ?ConditionInputType,
  propertyType?: ?ConditionInputType,
  apartamento?: ?ConditionInputType,
  saleBillingOutstandingAmount?: ?ConditionInputType,
  pendingSales?: ?ConditionInputType,
  invoicesCount?: ?ConditionInputType,
  subscriptionsCount?: ?ConditionInputType,
  activeSubscriptionCuota?: ?ConditionInputType,
  clientStatus?: ?ConditionInputType,
  paymentType?: ?ConditionInputType,
  nameSearch?: ?ConditionInputType,
|};
export type ConditionInputType = {|
  eq?: ?string,
  ne?: ?string,
  gt?: ?string,
  gte?: ?string,
  lt?: ?string,
  lte?: ?string,
  is?: ?string,
  not?: ?string,
  in?: ?$ReadOnlyArray<?string>,
  notIn?: ?$ReadOnlyArray<?string>,
  like?: ?string,
  notLike?: ?string,
  iLike?: ?string,
  insub?: ?string,
|};
export type ClientSelectQueryVariables = {|
  where?: ?ClientWhere
|};
export type ClientSelectQueryResponse = {|
  +clients: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +code: number,
        +name: string,
        +type: ?string,
        +location: ?{|
          +name: string,
          +id: string,
        |},
      |}
    |}>
  |}
|};
export type ClientSelectQuery = {|
  variables: ClientSelectQueryVariables,
  response: ClientSelectQueryResponse,
|};
*/


/*
query ClientSelectQuery(
  $where: ClientWhere
) {
  clients(where: $where, first: 10, orderBy: [name], order: ASC) {
    edges {
      node {
        id
        code
        name
        type
        location {
          name
          id
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "where",
    "type": "ClientWhere",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "clients",
    "storageKey": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 10
      },
      {
        "kind": "Literal",
        "name": "order",
        "value": "ASC"
      },
      {
        "kind": "Literal",
        "name": "orderBy",
        "value": [
          "name"
        ]
      },
      {
        "kind": "Variable",
        "name": "where",
        "variableName": "where"
      }
    ],
    "concreteType": "ClientConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "ClientEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Client",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "code",
                "args": null,
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "type",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "location",
                "storageKey": null,
                "args": null,
                "concreteType": "Location",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v1/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ClientSelectQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ClientSelectQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "ClientSelectQuery",
    "id": null,
    "text": "query ClientSelectQuery(\n  $where: ClientWhere\n) {\n  clients(where: $where, first: 10, orderBy: [name], order: ASC) {\n    edges {\n      node {\n        id\n        code\n        name\n        type\n        location {\n          name\n          id\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fa6ec605e16372d9ee24d24c0529401b';
module.exports = node;
